import { ShippingOption, ShippingOptionUpdate } from '@afterpaytouch/portal-api/types'
import { TerminalErrorCode } from './checkout'
import { TrackingEvent } from './monitoring'
export enum ShippingOptionErrorCode {
  SHIPPING_ADDRESS_UNRECOGNIZED = 'SHIPPING_ADDRESS_UNRECOGNIZED',
  SHIPPING_ADDRESS_UNSUPPORTED = 'SHIPPING_ADDRESS_UNSUPPORTED',
  MERCHANT_TIMEOUT = 'MERCHANT_TIMEOUT',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  BAD_RESPONSE = 'BAD_RESPONSE',
}

export enum ShippingOptionErrorType {
  Default = 'default',
  MerchantTimeout = 'merchantTimeout',
  ServiceUnavailable = 'serviceUnavailable',
  BadResponse = 'badResponse',
  ShippingAddressUnrecognised = 'shippingAddressUnrecognised',
  ShippingAddressUnsupported = 'shippingAddressUnsupported',
  TotalTooHighToLoadAnyOption = 'totalTooHighToLoadAnyOption',
  ShippingAddressIncomplete = 'shippingAddressIncomplete',
  ShippingOptionUpdateInvalid = 'ShippingOptionUpdateInvalid',
  ShippingOptionUnableToUpdate = 'ShippingOptionUnableToUpdate',
}

export enum ShippingOptionStatus {
  Initial,
  Loading,
  Loaded,
  UpdatingSelected,
  RequiresCheckoutUpdate,
  UpdatedSelected,
  Error,
}

export const ShippingOptionErrors: Partial<Record<ShippingOptionErrorCode, ShippingOptionErrorType>> = {
  [ShippingOptionErrorCode.SHIPPING_ADDRESS_UNSUPPORTED]: ShippingOptionErrorType.ShippingAddressUnsupported,
  [ShippingOptionErrorCode.SHIPPING_ADDRESS_UNRECOGNIZED]: ShippingOptionErrorType.ShippingAddressUnrecognised,
  [ShippingOptionErrorCode.MERCHANT_TIMEOUT]: ShippingOptionErrorType.MerchantTimeout,
  [ShippingOptionErrorCode.SERVICE_UNAVAILABLE]: ShippingOptionErrorType.ServiceUnavailable,
  [ShippingOptionErrorCode.BAD_RESPONSE]: ShippingOptionErrorType.BadResponse,
}

export const AmplitudeErrorEventNames: Partial<Record<ShippingOptionErrorType | TerminalErrorCode.InvalidPickupAddress, string>> = {
  [ShippingOptionErrorType.ShippingAddressUnsupported]: TrackingEvent.MERCHANT_UNSUPPORTED_SHIPPING_ADDRESS,
  [ShippingOptionErrorType.ShippingAddressUnrecognised]: TrackingEvent.MERCHANT_UNRECOGNIZED_SHIPPING_ADDRESS,
  [ShippingOptionErrorType.MerchantTimeout]: TrackingEvent.MERCHANT_SHIPPING_OPTIONS_TIMEOUT,
  [ShippingOptionErrorType.ServiceUnavailable]: TrackingEvent.MERCHANT_SHIPPING_OPTIONS_SERVICE_UNAVAILABLE,
  [ShippingOptionErrorType.BadResponse]: TrackingEvent.MERCHANT_SHIPPING_OPTIONS_BAD_RESPONSE,
  [ShippingOptionErrorType.TotalTooHighToLoadAnyOption]: TrackingEvent.MERCHANT_SHIPPING_OPTIONS_TOTAL_AMOUNT_TOO_HIGH,
  invalidPickupAddress: TrackingEvent.VIEWED_NO_PICKUP_ADDRESS_ERROR,
}

export const ShippingOptionAddressErrors: ShippingOptionErrorType[] = [
  ShippingOptionErrorType.ShippingAddressUnsupported,
  ShippingOptionErrorType.ShippingAddressUnrecognised,
  ShippingOptionErrorType.ShippingAddressIncomplete,
]

export function isShippingOptionErrorType(error: ShippingOptionErrorType | TerminalErrorCode): boolean {
  return Object.values(ShippingOptionErrorType).includes(error as ShippingOptionErrorType)
}

export interface ShippingOptionValidationError {
  severity: string
  message: string
  errorCode?: string
}
export interface ShippingOptionValidation extends ShippingOptionValidationError {
  allShippingOptions?: ShippingOption[]
  xbtAllShippingOptions?: ShippingOption[]
}

export interface ShippingOptionUpdateValidation extends ShippingOptionValidationError {
  shippingOption?: ShippingOptionUpdate
}
